.ax{flex:1;}